export enum NotificationRepetitionType {
  Daily = "Daily",
  Weekly = "Weekly"
}

export const NOTIFICATION_REPETITION_LIST = [
  {
    label: "day",
    value: NotificationRepetitionType.Daily
  },
  {
    label: "week",
    value: NotificationRepetitionType.Weekly
  }
];
